var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackspace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 36,
    viewBox: "0 0 24 24",
    width: 36,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17 15-6-5.99999m6-.00001-6 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.4 4.8c.37771-.50361.97049-.8 1.6-.8h11c1.1046 0 2 .89543 2 2v12c0 1.1046-.8954 2-2 2h-11c-.62951 0-1.22229-.2964-1.6-.8l-4.5-6c-.53333-.7111-.53333-1.6889 0-2.4z",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackspace);
export default __webpack_public_path__ + "static/media/backspace.e5c956560537558bbc203d1d3d85cd1c.svg";
export { ForwardRef as ReactComponent };